// extracted by mini-css-extract-plugin
module.exports = {"inlineAd":"oC","innerWrapper":"pC","tooltipWrapper":"qC","icon":"rC","tooltip":"sC","content":"tC"};